export const getHeaders = (apiToken) => {
  let headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };
  if (apiToken) {
    headers['Authorization'] = `${apiToken}`;
  }
  return headers;
};

export const handleResponse = (
  response,
  resourceName,
  setShowSuccess,
  setSuccessMessage,
  setShowError,
  setErrorMessage,
  navigate,
  successCreationDestination = ''
) => {
  let baseMessage = `${resourceName.charAt(0).toUpperCase() + resourceName.slice(1)} `;

  if (response.status === 200) {
    setShowSuccess(true);
    setSuccessMessage(baseMessage + 'updated successfully');
  } else if (response.status === 201) {
    setShowSuccess(true);
    setSuccessMessage(baseMessage + 'created successfully');
    if (successCreationDestination) {
      resourceName = resourceName.toLowerCase();
      navigate(successCreationDestination.replace(':id', response.data.data[`${resourceName}_id`] || response.data.data));
    }
  } else {
    console.error(`Failed to save ${resourceName} data:`, response);
    setShowError(true);
    setErrorMessage(`Failed to save ${resourceName} data`);
  }
};

export const handleErrorResponse = (
  error,
  navigate,
  setShowError = null,
  setErrorMessage = null
) => {
  if (error.response) {    
    const maxRefreshAttempts = 3;
    let currentUrl = new URL(window.location.href);
    let refreshAttempts = parseInt(currentUrl.searchParams.get('retry') || '0', 10);

    if (error.response.status === 403 || error.response.status === 401) {
      const returnUrl = window.location.pathname;
      navigate(`/?sessionExpired=true&returnUrl=${encodeURIComponent(returnUrl)}`);
    }
    else if (error.response.status === 503) {
      if (refreshAttempts < maxRefreshAttempts) {
        refreshAttempts++;
        currentUrl.searchParams.set('retry', refreshAttempts.toString());
        window.location.href = currentUrl.href;
      } else {
        const returnUrl = window.location.pathname;
        navigate(`/?sessionExpired=true&returnUrl=${encodeURIComponent(returnUrl)}`);
      }
    } else {
      // Handle other status codes or general error
      if (setShowError) setShowError(true);
      if (setErrorMessage) {
        // Try to extract the specific error message from the API response
        const apiMessage = error.response?.data?.message || error.response?.data?.error || error.message;
        setErrorMessage(apiMessage);
      }
    }
  } else {
    // If the error doesn't have a response (e.g., network error)
    if (setShowError) setShowError(true);
    if (setErrorMessage) setErrorMessage('Network error or server is unreachable.');
  }
};